import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
// import styles from './DBDropDown.module.css';




class DBDropDownPDC extends React.Component {

    updateField(event) {
        if (this.props.onChange) {
            this.props.onChange(event);
        }
        if (!event.isPropagationStopped()) {
            if (event.target.value === '-1') {
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field);
            }
            else if (this.props.type === 'int') {
                this.props.updateIntField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, parseInt(event.target.value));
            } else {
                this.props.updateTextField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, event.target.value.toString());
            }
        }
    }

    render() {
        return (
            // TODO: was trying to overlay placeholder text if no value was selected.  This was causing
            // layout issues but the concept was close.
            // <div style={{ height: '1px' }} className={this.props.className}>
            //     {this.props.placeholder && !this.props.value &&
            //         <div className={styles.placeholder}>{this.props.placeholder}</div>
            //     }
            <select
                // style={{ position: 'absolute' }}
                title={this.props.title}
                value={this.props.value !== undefined ? this.props.value : -1}
                name={this.props.field}
                className={this.props.className}
                disabled={this.props.disabled}
                onChange={(event) => this.updateField(event)}
            >
                <option key={-1} value={-1}></option>

                {this.props.customOptions &&
                    Object.keys(this.props.customOptions)
                        .map(id => {
                            const option = this.props.customOptions[id];
                            return (
                                <option key={option.id} value={option.id}>{option.value}</option>
                            );
                        })
                }
                {!this.props.customOptions &&
                    Object.keys(this.props.options)
                        .map(id => {
                            const option = this.props.options[id];
                            return (
                                <option key={option['WFNO']} value={option['WFNO']}>{option['WFNAME']}</option>
                            );
                        })
                }
            </select>
            // </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    return {
        value: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== undefined &&
            state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== null ?
            state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] : -1,
        type: state.entities.masterData.PTERONOTESCHEMA[ownprops.entity + '.' + ownprops.field].DATA_TYPE,
        options:
            Object.keys(state.entities.masterData['PTMASTERWCPDCFREQ'])
                .filter(x => (ownprops.isCurrent === true && state.entities.masterData.PTMASTERWCPDCFREQ[x].WFCURRENT === true)
                    || (ownprops.isCurrent === false && state.entities.masterData.PTMASTERWCPDCFREQ[x].WFJOBREQ === true))
                .sort((a, b) => state.entities.masterData['PTMASTERWCPDCFREQ'][b]['WFORDER'] > state.entities.masterData['PTMASTERWCPDCFREQ'][a]['WFORDER'] ? -1 : 1)
                .map(key => state.entities.masterData['PTMASTERWCPDCFREQ'][key]),

    };
}

const connectedDBDropDownPDC = connect(mapStateToProps, mapDispatchToProps)(DBDropDownPDC);
export { connectedDBDropDownPDC as DBDropDownPDC };